import { useFlippers } from "@shared/hooks/useFlippers/useFlippers";

const useFullscriptJsDS4 = () => {
  const [isFullscriptJsDS4Enabled] = useFlippers("phoenix_fsjs_ds4");

  return isFullscriptJsDS4Enabled;
};

export { useFullscriptJsDS4 };
